import { BrowserRouter as Router } from "react-router-dom";
import MainComponent from "./components/main-layout";
import AuthProvider from "./providers/AuthProvider";
import { GleapProvider } from "./providers/gleap-provider";

function App() {
  return (
    <Router>
      <AuthProvider>
        <GleapProvider>
          <MainComponent />
        </GleapProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
